import { render, staticRenderFns } from "./RelatedSingle.vue?vue&type=template&id=dfce18b8&"
import script from "./RelatedSingle.vue?vue&type=script&lang=js&"
export * from "./RelatedSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports